<script lang="ts" setup>
import { AuthForgotPasswordForm } from '@/modules/auth/components';

useHead({
  title: 'Reset Password',
});

definePageMeta({
  layout: 'guest',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
});
</script>

<template>
  <v-container class="ma-auto d-flex justify-center w-full hero">
    <AuthForgotPasswordForm class="py-6" />
  </v-container>
</template>

<style lang="scss" scoped>
.v-card {
  margin-top: 132px;
}
</style>
